import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryTeamType = () => {
  return <CategoryBase baseEndpoint="category_team_type" />;
};

export default CategoryTeamType;
